import * as yup from 'yup'

export const editAcessoUsuariosFormSchema = yup.object().shape({
    idGrupoAcesso: yup.number().typeError('Campo obrigatório'),
    nome: yup.string().required('Campo obrigatório'),
    email: yup.string().email('E-mail inválido'),
    login: yup.string().required('Campo obrigatório'),
    nroDocumento: yup.string().required('Campo obrigatório'),
    dtNascimento: yup.string().required('Campo obrigatório'),
})